import { createFileRoute } from '@tanstack/react-router';
import { RunDetailPage } from '@/pages/runs/RunDetailPage';

export const Route = createFileRoute('/runs/$workflowId')({
  component: RunDetailRoute,
});

function RunDetailRoute() {
  const { workflowId } = Route.useParams();
  return <RunDetailPage workflowId={workflowId} />;
}
